<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="カードコピー">
     カードコピー
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history.html#change-history_ja" title="変更履歴">
     変更履歴
    </a>
   </p>
   <div id="divd0e8">
   </div>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter_ja" title="概要">
     概要
    </a>
   </p>
   <div id="divd0e33">
   </div>
   <p class="toc-1-style">
    <a href="installing-orders-routing-chapter.html#installing-orders-routing-chapter_ja" title="アプリケーションを設定する">
     アプリケーションを設定する
    </a>
   </p>
   <div id="divd0e51">
    <p class="toc-2-style">
     <a href="accessing-ews-topic.html#accessing-ews_ja" title="内蔵 Web サーバーにアクセスする">
      内蔵 Web サーバーにアクセスする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-application-icon-esf-moja-topic.html#customizing-application-icon-esf-moja_ja" title="アプリケーションアイコンをカスタマイズする">
      アプリケーションアイコンをカスタマイズする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-options-card-copy-topic.html#configuring-options-card-copy_ja" title="オプションの設定">
      オプションの設定
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-or-exporting-configuration-file-esf-moja-topic.html#importing-or-exporting-configuration-file-esf-moja_ja" title="設定ファイルをインポートまたはエクスポートする">
      設定ファイルをインポートまたはエクスポートする
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-orders-routing-chapter.html#using-orders-routing-chapter_ja" title="アプリケーションを使用する">
     アプリケーションを使用する
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="loading-cards-on-scanner-glass-topic.html#loading-cards-on-scanner-glass_ja" title="カードを原稿台にセットする">
      カードを原稿台にセットする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-cards-card-copy-topic.html#scanning-cards-card-copy_ja" title="カードのスキャンとコピー">
      カードのスキャンとコピー
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-scan-settings-card-copy-topic.html#adjusting-scan-settings-card-copy_ja" title="スキャン設定を調整する">
      スキャン設定を調整する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting.html#troubleshooting_ja" title="問題に対処する">
     問題に対処する
    </a>
   </p>
   <div id="divd0e344">
    <p class="toc-2-style">
     <a href="application-error-scanning-trb-esf-builtin-moja-topic.html#application-error-scanning-trb-esf-builtin-moja_ja" title="アプリケーションエラー">
      アプリケーションエラー
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-network-destination-stopped-working-topic.html#trb-network-destination-stopped-working_ja" title="ネットワークの保存先が動作を停止した、または無効である">
      ネットワークの保存先が動作を停止した、または無効である
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-scan-cards-properly-topic.html#cannot-scan-cards-properly_ja" title="カードを正しくスキャンできない">
      カードを正しくスキャンできない
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-send-the-file-topic.html#cannot-send-the-file_ja" title="ファイルを送信できない">
      ファイルを送信できない
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-scan-multiple-cards-topic.html#cannot-scan-multiple-cards_ja" title="複数のカードをスキャンできない">
      複数のカードをスキャンできない
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-scan-to-selected-destination-card-copy-topic.html#cannot-scan-to-selected-destination-card-copy_ja" title="選択した保存先に取り込めない">
      選択した保存先に取り込めない
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices_ja" title="通知">
     通知
    </a>
   </p>
   <div id="divd0e632">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e635" title="改訂通知">
      改訂通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#trademarks_ja" title="商標">
      商標
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue